import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Card, CardBody, Container } from 'reactstrap';
import { changeEmailPerformFromLink } from '../../redux/methods/auth';

const STATUS = {
    PENDING: 'pending',
    SUCCESS: 'success',
    ERROR: 'error',
    MISSING_TOKEN: 'missing-token',
};

const ChangeEmailConfirm = ({ location, changeEmailPerformFromLink }) =>
{
    const intl = useIntl();
    const translations = intl.messages.accountSettings.changeEmailConfirm;

    const [status, setStatus] = useState(STATUS.PENDING);

    const token = useMemo(() => {
        const query = new URLSearchParams(location.search);
        return query.get('token');
    }, [location.search]);

    useEffect(() =>
    {
        let isCurrent = true;

        const performChangeEmail = async () =>
        {
            if (!token)
            {
                setStatus(STATUS.MISSING_TOKEN);
                return;
            }

            setStatus(STATUS.PENDING);
            const success = await changeEmailPerformFromLink({ token });
            if (!isCurrent) { return; }
            setStatus(success ? STATUS.SUCCESS : STATUS.ERROR);
        };

        performChangeEmail();
        return () => { isCurrent = false; };
    },
    [token, changeEmailPerformFromLink]);

    const statusView =
    {
        [STATUS.PENDING]: {
            color: 'info',
            title: translations.pending.title,
            description: translations.pending.description,
            showBackButton: false,
        },
        [STATUS.SUCCESS]: {
            color: 'success',
            title: translations.success.title,
            description: translations.success.description,
            showBackButton: true,
        },
        [STATUS.ERROR]: {
            color: 'danger',
            title: translations.error.title,
            description: translations.error.description,
            showBackButton: true,
        },
        [STATUS.MISSING_TOKEN]: {
            color: 'warning',
            title: translations.missingToken.title,
            description: translations.missingToken.description,
            showBackButton: true,
        },
    }[status];

    return (
        <Container fluid className="mt-3">
            <Card>
                <CardBody>
                    <h1>{statusView.title}</h1>

                    <Alert color={statusView.color} className="mt-3">
                        {statusView.description}
                    </Alert>

                    {statusView.showBackButton && (
                        <Link className="btn btn-primary" to="/panelUsers/account">
                            {translations.backToAccountSettings}
                        </Link>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
};

ChangeEmailConfirm.propTypes = {
    location: PropTypes.object,
    changeEmailPerformFromLink: PropTypes.func,
};

const mapDispatch = {
    changeEmailPerformFromLink,
};

export default connect(null, mapDispatch)(ChangeEmailConfirm);